<template>
  <span class="m12">{{ time | relativeDateFilter }}</span>
</template>

<script >
export default {
  props:{
    time:''
  }
}
</script>

<style scoped>
.m12{
  margin-left: 12px;
  color: #ff6e6e;
}
</style>